export default {
  '--app-primary-color': '#ff6801',
  '--app-secondary-color': '#ff944c',
  '--app-tertiary-color': 'hsl(241, 98%, 95%)',
  '--app-disabled-color': 'hsl(0, 0%, 89%)',
  '--sidebar-bg-color': 'hsl(0, 0%, 95%)',
  '--sidebar-icon-color': '#ff6801',
  '--sidebar-text-color': 'hsl(0, 0%, 13%)',
  '--sidebar-active-bg-color': '#ff6801',
  '--sidebar-active-text-color': 'hsl(0, 0%, 100%)'
};